/*/// <reference types="@types/googlemaps" />*/
/// <reference types="@types/google.maps" />

import { Component, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import moment from 'moment';
import { PageBase, SmartLockHistoryInfo } from 't4core';

@Component({
  styleUrls: ['./object-gps-map.css'],
  selector: 'object-gps-map',
  templateUrl: './object-gps-map.component.html',
})
export class ObjectGpsMapComponent extends PageBase implements OnInit {
  constructor(el: ElementRef, private fb: FormBuilder, private router: Router) {
    super(el, 'ObjectGpsMapComponent');
  }

  @ViewChild('gmap', { static: true }) gmapElement: any;
  @ViewChild('txtMapSearch', { static: true }) gmapSearchBox: ElementRef;
  @Input() public lockId: string;
  public mapHistory: SmartLockHistoryInfo[] = [];
  public isLoading: boolean = false;
  private map: google.maps.Map;
  private searchBox: google.maps.places.Autocomplete;
  private infoWindow = new google.maps.InfoWindow();
  private marker: google.maps.marker.AdvancedMarkerElement;

  public selectedHistoryIndex: number = 0;

  public selectedDate: Date; 


  async ngOnInit() {
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

    const { } = await google.maps.importLibrary("maps") as google.maps.MapsLibrary;

    this.isLoading = true;
    if (this.lockId) {
      this.mapHistory = await this.Api.get<SmartLockHistoryInfo[]>("RentalObject/GetGPSLockHistoryInfo", { lockId: this.lockId });
    }    
    this.isLoading = false; 

    this.map = new google.maps.Map(this.gmapElement.nativeElement, {
      center: new google.maps.LatLng(60.5793, 14.8143),
      zoom: 6,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapId: '2bfb441deccab4d5b8508848',
    });

    if (this.mapHistory.length > 0) {
      console.log(this.mapHistory);
      this.setLatestHistoryLocation();
    }

    this.renderTrail();

  }

  private setLatestHistoryLocation() {
    const latestEntry = this.mapHistory[0];
    const latestPosition = new google.maps.LatLng(latestEntry.Latitude, latestEntry.Longitude);
    this.selectedHistoryIndex = 0;

    if (this.marker) {
      this.marker.map = null;
    }

    this.marker = new google.maps.marker.AdvancedMarkerElement({
      position: latestPosition,
      map: this.map,
      /*animation: google.maps.Animation.DROP,*/
    });

    this.map.setCenter(latestPosition);
    this.map.setZoom(16);
  }

  public updateSetting(event) {
    this.selectedHistoryIndex = event;
    this.onHistoryChange();
  }


  public updateHistory(delta: number) {
    if (this.mapHistory.length === 0) return;

    const atFirst = this.selectedHistoryIndex <= 0;
    const atLast = this.selectedHistoryIndex >= this.mapHistory.length - 1;

    if ((delta > 0 && atLast) || (delta < 0 && atFirst)) return;

    this.selectedHistoryIndex += delta;
    this.onHistoryChange();
  }


  public onHistoryChange() {
    if (this.mapHistory.length > 0) {
      const selectedHistory = this.mapHistory[this.selectedHistoryIndex - 1];
      const position = new google.maps.LatLng(selectedHistory.Latitude, selectedHistory.Longitude);
      console.log("Position");
      console.log(position);
      if (this.marker) {
        this.marker.map = null;
      }

      this.marker = new google.maps.marker.AdvancedMarkerElement({
        position,
        map: this.map,
        /*animation: google.maps.Animation.DROP,*/
      });

      this.map.panTo(position);
      //setTimeout(() => this.map.setZoom(16), 500);

      //this.infoWindow.setContent('Date: ' + selectedHistory.Created.toDate().toLocaleString());
      //this.infoWindow.open(this.map, this.marker);
    }
  }

  private _trailSegments: google.maps.Polyline[] = [];

  private clearTrail() {
    this._trailSegments.forEach(s => s.setMap(null));
    this._trailSegments = [];
  }

  public renderTrail() {
    console.log("RUN");
    const history = this.mapHistory ?? [];
    if (history.length < 2) return;

    //Get the Last 300 recent locations, order by desc. And have to not be older then 10 days.

    const daysLimit = moment().subtract(100, "days");
    const recent = history.filter(h => {
      const ts = h.TimeStamp;
      const m = moment.isMoment(ts) ? ts : moment(ts);
      return m.isValid() && m.isSameOrAfter(daysLimit);
    });

    if (recent.length < 2) return;

    const recentLocations = recent;

    const pointsLocations = recentLocations
      .map(p => ({ lat: Number(p.Latitude), lng: Number(p.Longitude) }))
      .filter(p => Number.isFinite(p.lat) && Number.isFinite(p.lng));

    if (pointsLocations.length < 2) return;

    this.clearTrail();
    console.log(recentLocations);
    // <=== Configurations / Settings ===>
    const groupSize = 10;      // How many steps before decreasing the opacitiy.
    const minOpacity = 0.2;    

    const totalSegments = pointsLocations.length - 1;
    const totalGroups = Math.max(1, Math.ceil(totalSegments / groupSize));

    for (let i = 0; i < totalSegments; i++) {
      const group = Math.floor(i / groupSize);        
      
      const t = totalGroups === 1 ? 0 : group / (totalGroups - 1); 
      const opacity = minOpacity + (1 - minOpacity) * (1 - t);     

      const seg = new google.maps.Polyline({
        path: [pointsLocations[i], pointsLocations[i + 1]],
        geodesic: true,
        strokeColor: "#ff5f00",
        strokeOpacity: opacity,
        strokeWeight: 5,
        map: this.map,
      });
      this._trailSegments.push(seg);
    }

    const bounds = new google.maps.LatLngBounds();
    pointsLocations.forEach(pt => bounds.extend(pt));
    this.map.fitBounds(bounds);

  }


  private toMoment(ts: any): moment.Moment {
    return moment.isMoment(ts) ? ts : moment(ts);
  }

  private getClosestHistoryIndex(target: moment.Moment): number {
    const arr = this.mapHistory ?? [];
    const n = arr.length;
    if (n === 0) return -1;

    const targetMs = +target;
    const firstMs = +this.toMoment(arr[0].TimeStamp);
    const lastMs = +this.toMoment(arr[n - 1].TimeStamp);

    if (targetMs <= firstMs) return 0;
    if (targetMs >= lastMs) return n - 1;

    let lo = 0, hi = n - 1;
    while (lo <= hi) { 
      const mid = (lo + hi) >> 1;
      const midMs = +this.toMoment(arr[mid].TimeStamp);
      if (midMs === targetMs) return mid;
      if (midMs < targetMs) lo = mid + 1;
      else hi = mid - 1;
    }

    const beforeMs = +this.toMoment(arr[hi].TimeStamp);
    const afterMs = +this.toMoment(arr[lo].TimeStamp);
    return (targetMs - beforeMs <= afterMs - targetMs) ? hi : lo;
  }

  public searchOnDate() {
    if (!this.selectedDate || !this.mapHistory?.length) return;
    const target = moment(this.selectedDate);
    if (!target.isValid()) return;

    // try same-day
    const sameDay = this.mapHistory
      .map((h, i) => ({ i, m: this.toMoment(h.TimeStamp) }))
      .filter(x => x.m.isValid() && x.m.isSame(target, 'day'));

    let idx: number;
    if (sameDay.length) {
      // pick nearest within the day
      sameDay.sort((a, b) => Math.abs(+a.m - +target) - Math.abs(+b.m - +target));
      idx = sameDay[0].i;
    } else {
      // fallback
      idx = this.getClosestHistoryIndex(target);
    }

    this.selectedHistoryIndex = (idx === 0) ? 0 : (idx + 1);

    this.onHistoryChange();

    const h = this.mapHistory[idx];
    const lat = Number(h.Latitude), lng = Number(h.Longitude);
    if (Number.isFinite(lat) && Number.isFinite(lng)) {
      this.map.panTo({ lat, lng });
    }
  }


}
